import { useComponentWillMount } from '../../features/shared/public/SlUtils/useComponentWillMount';
import { Container } from '../../features/symphony';

export const useInitCookies = (cookies: { cookies?: Record<string, string> }) => {
	useComponentWillMount(() => {
		Container.register('global', 'cookies', cookies);
	});
};
